import { render, staticRenderFns } from "./xkt-detail.vue?vue&type=template&id=33ba1948&"
import script from "./xkt-detail.vue?vue&type=script&lang=ts&"
export * from "./xkt-detail.vue?vue&type=script&lang=ts&"
import style0 from "./xkt-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports